export default "__VITE_ASSET__CgMP2OMa__"